import moment from 'moment';

import {
    getCreateDateTime
} from '../../utils/DateUtils';

export const payMasterModel = () => {
    return {
        // สำหรับตารางจ่าย
        datePay: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        amountPay: 0,

        // ข้อมูลทั่วไป
        payId: null,
        payNo: null,
        payDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docDueDate: null,
        docPayDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        payStatus: 1,
        payType: 1,
        refDocID: null,
        refDoc: null,
        refDocDate: null,
        refProjectID: null,
        refProjectNo: null,
        compId: null,
        transportType: 1,
        docRemark1: null,
        docRemark2: null,
        apID: null,
        apCode: null,
        apName: null,
        arID: null,
        arCode: null,
        arName: null,
        actionHold: null,
        discountValue: 0,
        discountValueType: null,
        discountValueTotal: 0,
        discountCash: null,
        discountCashType: null,
        discountTransport: null,
        discountTransportType: null,
        isVat: null,
        docSEQ: null,
        creditTerm: null,
        creditTerm1Day: null,
        creditTerm1Remark: null,
        creditTerm2Remark: null,
        accCode: null,
        empName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        approvedDate: null,
        approvedByName: null,
        approvedById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        approvedMemo: null,
        printedStatus: null,
        printedDate: null,
        printedBy: null,
        cancelMemo: null,
        isWTAX:"N",
    };
};